module.exports = __webpack_public_path__ + "static/media/quiz.73fcf882.gif";